/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, gsap) => {
		/*
		|
		| Constants
		|-----------
		*/
        const
            $body         = $('body'),
            $flexibleTabs = $('.flexible-tabs'),
            url 		  = new URL(window.location)
		;

		/*
		|
		| Tabs
		|-----------
		*/
		if ( $flexibleTabs.length ) {

			// URL Location (Anchors - Anchor Tabs)
			if (url.search) {

				let
					searchParams = url.searchParams,
					id			 = searchParams.get('id'),
					tab			 = parseInt(searchParams.get('tab'))
				;

				if (id || tab) {

					let $tabSection = $(`#${id}`);

					if (tab) {

						const
							$tabTitles   = $tabSection.find('[data-tab-title]'),
							$tabContents = $tabSection.find('[data-tab-content]')
						;

						$tabTitles.removeClass('active');
						$tabContents.removeClass('active');

						$tabSection.find(`[data-tab-title][data-index="${tab}"]`).addClass('active');
						$tabSection.find(`[data-tab-content][data-index="${tab}"]`).addClass('active');
						
					}

					$('html, body').animate({
						scrollTop: $tabSection.offset().top - ( $('#header').outerHeight() + 70)
					}, 2000);
					
				}
				
			}

			$.each($flexibleTabs, (index, element) => {

				const
					$tabTitles   = $(element).find('[data-tab-title]'),
					$tabContents = $(element).find('[data-tab-content]')
				;
	
				$tabTitles.on('click', (e) => {
	
					let
						$currentTarget = $(e.currentTarget),
						currentIndex = $currentTarget.get(0).dataset.index
					;
	
					if ( !( $currentTarget.hasClass('active') ) ) {
	
						$tabTitles.removeClass('active');
						$currentTarget.addClass('active');
						
						$tabContents.removeClass('active');
						// $(`[data-tab-content][data-index="${ currentIndex }"]`).addClass('active');
						$($tabContents.get(currentIndex - 1)).addClass('active');
	
					}
	
				});

			});
			
		}



        $body.on('loaderEnd', () => console.log('ended'))
	}
}
